import { API_HOST } from "@/config";

function formatUrl(baseUrl: string, path: string): string {
  const url = new URL(path, baseUrl);

  return url.toString();
}

export async function get<T = unknown>(url: string): Promise<T> {
  const response = await fetch(formatUrl(API_HOST, url));

  if (!response.ok) {
    throw new Error("An error occurred while fetching the data.");
  }

  return response.json() as Promise<T>;
}

type Params = Record<string, unknown>;

export async function post<T = unknown>(
  url: string,
  data?: Params,
): Promise<T> {
  const response = await fetch(formatUrl(API_HOST, url), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    ...(data && {
      body: JSON.stringify(data),
    }),
  });

  if (!response.ok) {
    let errorBody: unknown;
    try {
      errorBody = await response.json();
    } catch {
      throw new Error(`HTTP error ${response.status}`);
    }

    if (errorBody instanceof Error) {
      throw errorBody;
    } else {
      throw new Error(
        typeof errorBody === "string"
          ? errorBody
          : `HTTP error ${response.status}`,
      );
    }
  }

  return response.json() as Promise<T>;
}

export async function put<T = unknown>(url: string, data: T): Promise<T> {
  const response = await fetch(formatUrl(API_HOST, url), {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("An error occurred while putting the data.");
  }

  return response.json() as Promise<T>;
}

export async function remove(url: string): Promise<void> {
  const response = await fetch(formatUrl(API_HOST, url), {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("An error occurred while deleting the data.");
  }

  return;
}
